// extracted by mini-css-extract-plugin
export default {"addToCartControl":"LX-z","giftCard":"MX-z","btnContainer":"NX-z","cartButton":"OX-z","disabled":"PX-z"};